import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "roaming-info__details" }
const _hoisted_2 = { class: "roaming-info__details-wrapper" }
const _hoisted_3 = { class: "roaming-info__details-name" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "h2 color-text-primary" }
const _hoisted_6 = { class: "roaming-info__details-others" }
const _hoisted_7 = { class: "roaming-info__details-others__text" }
const _hoisted_8 = { class: "caption-medium normal" }
const _hoisted_9 = { class: "roaming-info__details-conditions" }
const _hoisted_10 = { class: "roaming-info__details-conditions__title" }
const _hoisted_11 = { class: "color-text-primary bold" }
const _hoisted_12 = {
  key: 0,
  class: "roaming-info__details-conditions__list"
}
const _hoisted_13 = { class: "roaming-info__details-conditions__resource-title" }
const _hoisted_14 = { class: "caption-normal color-text-primary bold" }
const _hoisted_15 = { class: "roaming-info__details-conditions__resource-options" }
const _hoisted_16 = { class: "roaming-info__details-conditions__resource-options__item-text" }
const _hoisted_17 = { class: "caption-medium" }
const _hoisted_18 = { class: "roaming-info__details-conditions__resource-options__item-value" }
const _hoisted_19 = { class: "caption-medium color-text-primary thick" }
const _hoisted_20 = { class: "roaming-info__details-promo" }
const _hoisted_21 = { class: "roaming-info__details-promo__wrapper" }
const _hoisted_22 = { class: "roaming-info__details-promo__header" }
const _hoisted_23 = { class: "roaming-info__details-promo__header-title" }
const _hoisted_24 = { class: "color-text-primary bold h2" }
const _hoisted_25 = { class: "roaming-info__details-promo__content" }
const _hoisted_26 = { class: "color-text-secondary caption-medium" }
const _hoisted_27 = { class: "roaming-info__details-promo__action" }
const _hoisted_28 = { class: "roaming-info__details-promo__action-price" }
const _hoisted_29 = { class: "roaming-info__details-promo__action-price__title" }
const _hoisted_30 = { class: "footnote color-text-secondary thick" }
const _hoisted_31 = { class: "roaming-info__details-promo__action-activate" }

import type {
  RoamingCountryStruct,
  RoamingZoneStruct,
} from "@/struct/RoaminStruct";
import type { PropType } from "@vue/runtime-core";
import RoamingCountersListWindow from "@/components/roaming/RoamingCountersListWindow.vue";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseModal from "@/components/base/BaseModal.vue";
import { useI18n } from "vue-i18n";
import { useRoamingInfoDetails } from "@/composables/roaming/useRoamingInfoDetails";


export default /*@__PURE__*/_defineComponent({
  __name: 'RoamingInfoDetails',
  props: {
  country: {
    type: Object as PropType<RoamingCountryStruct>,
    required: true,
  },
  zone: {
    type: Object as PropType<RoamingZoneStruct | null>,
    default: null,
  },
  othersCountriesList: {
    type: Object as PropType<RoamingCountryStruct[] | null>,
    default: null,
  },
  othersCountriesCount: {
    type: Number,
    default: 0,
  },
},
  emits: ["select"],
  setup(__props) {

const props = __props;



const { t } = useI18n();
const {
  activate,
  closeAllModal,
  conditions,
  formatAmount,
  isAlreadyAdded,
  isIncompatible,
  isLoadingActivate,
  isShowOthers,
  isSuccessful,
  isUnhandledError,
  isUnsuccessful,
  othersCountriesCountFormat,
  toPayment,
  toggleCheckOthers,
} = useRoamingInfoDetails(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "roaming-info__details-name__image",
            src: __props.country?.img_url,
            alt: _unref(t)('roaming.list.flagAlt')
          }, null, 8, _hoisted_4),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.country?.country_name_ru), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("roaming.details.sameConditionsFor", {
                count: _unref(othersCountriesCountFormat),
              })), 1),
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleCheckOthers) && _unref(toggleCheckOthers)(...args))),
              class: "caption-medium color-primary normal roaming-info__details-others__check"
            }, _toDisplayString(_unref(t)("roaming.details.viewList")), 1)
          ]),
          _createVNode(_Transition, {
            name: "drop",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (__props.othersCountriesList && _unref(isShowOthers))
                ? (_openBlock(), _createBlock(RoamingCountersListWindow, {
                    key: 0,
                    class: "roaming-info__details-others__list",
                    countersList: __props.othersCountriesList
                  }, null, 8, ["countersList"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)("roaming.details.baseConditions")), 1)
          ]),
          (__props.zone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conditions), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "roaming-info__details-conditions__resource",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(item.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (optionItem, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "roaming-info__details-conditions__resource-options__item",
                          key: idx
                        }, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(optionItem.text), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(formatAmount)(optionItem.value)), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h4", _hoisted_24, _toDisplayString(_unref(t)("roaming.details.promo.title")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)("roaming.details.promo.description")), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)("roaming.details.promo.priceTitle")), 1)
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "roaming-info__details-promo__action-price__value" }, [
                  _createElementVNode("span", { class: "bold caption-large color-text-primary" }, "600 ₽")
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(BaseButton, {
                  title: _unref(t)('common.actions.connect'),
                  disabled: _unref(isLoadingActivate),
                  onClick: _unref(activate)
                }, null, 8, ["title", "disabled", "onClick"])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: ".root" }, [
      (_unref(isSuccessful))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 0,
            title: _unref(t)('roaming.details.modals.successTitle'),
            "main-btn-title": _unref(t)('common.actions.ok'),
            onClose: _unref(closeAllModal),
            onAction: _unref(closeAllModal)
          }, null, 8, ["title", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(isUnsuccessful))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 1,
            title: _unref(t)('roaming.details.modals.insufficientFundsTitle'),
            text: _unref(t)('roaming.details.modals.insufficientFundsText'),
            "main-btn-title": _unref(t)('common.buttons.topUpBalance'),
            onClose: _unref(closeAllModal),
            onAction: _unref(toPayment)
          }, null, 8, ["title", "text", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(isUnhandledError))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 2,
            title: _unref(t)('common.errors.title'),
            text: _unref(t)('common.errors.retryRequest'),
            "main-btn-title": _unref(t)('common.actions.ok'),
            onClose: _unref(closeAllModal),
            onAction: _unref(closeAllModal)
          }, null, 8, ["title", "text", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(isIncompatible))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 3,
            title: _unref(t)('common.errors.title'),
            text: _unref(t)('roaming.details.modals.incompatibleText'),
            "main-btn-title": _unref(t)('common.actions.ok'),
            onClose: _unref(closeAllModal),
            onAction: _unref(closeAllModal)
          }, null, 8, ["title", "text", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(isAlreadyAdded))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 4,
            title: _unref(t)('common.errors.title'),
            text: _unref(t)('roaming.details.modals.alreadyAddedText'),
            "main-btn-title": _unref(t)('common.actions.ok'),
            onClose: _unref(closeAllModal),
            onAction: _unref(closeAllModal)
          }, null, 8, ["title", "text", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})